The image URLs for the identity verified icon in both light and dark mode.
